<p-toast styleClass="maxzindex" [autoZIndex]="false"></p-toast>
<p-confirmDialog header="Confirmation" class="maxzindex" [autoZIndex]="false" icon="pi pi-exclamation-triangle" [blockScroll]="true" styleClass="new-line maxzindex"></p-confirmDialog>
<ng-template ngFor let-item [ngForOf]="commonService?.loaderList" let-i="index">
    <div class="loading-bg"> 
    <div class="loading">
      <!-- <h2>Vetrotech</h2> -->
      <span>v</span>
      <span>e</span>
      <span>t</span>
      <span>r</span>
      <span>o</span>
      <span>t</span>
      <span>e</span>
      <span>c</span>
      <span>h</span>
    </div>
  </div>
</ng-template>

<router-outlet></router-outlet>